import { render, staticRenderFns } from "./FormCheckboxNew.vue?vue&type=template&id=0b88a5c4&scoped=true"
import script from "./FormCheckboxNew.vue?vue&type=script&lang=ts"
export * from "./FormCheckboxNew.vue?vue&type=script&lang=ts"
import style0 from "./FormCheckboxNew.vue?vue&type=style&index=0&id=0b88a5c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88a5c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b88a5c4')) {
      api.createRecord('0b88a5c4', component.options)
    } else {
      api.reload('0b88a5c4', component.options)
    }
    module.hot.accept("./FormCheckboxNew.vue?vue&type=template&id=0b88a5c4&scoped=true", function () {
      api.rerender('0b88a5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormCheckboxNew.vue"
export default component.exports